import Head from "next/head";
import Image from "next/image";
import styles from "../../styles/Home.module.css";
import {
  theme,
  ThemeProvider,
  CSSReset,
  Container,
  Box,
  Text,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  Link,
  Button,
  Collapse,
  Checkbox,
  Stack,
  Textarea,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Spinner,
  Center,
  Grid,
  GridItem,
  SimpleGrid,
  Flex,
  Spacer,
  Wrap,
  WrapItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  List,
  ListItem,
  ListIcon,
  OrderedList,
  UnorderedList,
} from "@chakra-ui/react";

import BaseLayout from "../../components/base_layout";

export default function Home() {
  return (
    <BaseLayout>
      <Box className="base_container">
        <Stack spacing={1} width={400} marginTop={20}>
          <Text>주문자명</Text>
          <Input
            variant="outline"
            id="id"
            name="email"
            placeholder="주문자명을 입력해주세요."
            color="#ccc"
            marginTop="2"
            padding="6"
          />
        </Stack>
        <Stack spacing={1} marginTop={5}>
          <Text>주문번호</Text>
          <Input
            color="#ccc"
            variant="outline"
            placeholder="주문번호를 입력해주세요."
            id="password"
            name="password"
            padding="6"
          />
        </Stack>

        <Stack spacing={4} direction="row" align="center">
          <Button
            colorScheme="red"
            size="lg"
            width="100%"
            padding="7"
            marginTop={5}
            fontSize="16"
            letterSpacing="-1px"
          >
            주문조회
          </Button>
        </Stack>

        <Button
          variant="outline"
          colorScheme="red"
          size="lg"
          width="100%"
          padding="7"
          marginTop={2}
          fontSize="16"
          letterSpacing="-1px"
        >
          비회원 구매
        </Button>

        <UnorderedList
          fontSize="11"
          mt="5"
          letterSpacing="-0.5px"
          color="#666"
          marginBottom={20}
        >
          <ListItem>
            구매번호는 발송된 알림톡 또는 이메일에서 확인하실 수 있습니다.
          </ListItem>
          <ListItem>
            구매번호가 생각나지 않는 경우, 고객센터(070-742-4989)로 문의
            부탁드립니다.
          </ListItem>
        </UnorderedList>
      </Box>
    </BaseLayout>
  );
}
